"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFuzzySearchResults = exports.useFuzzySearch = void 0;
var fuse_js_1 = __importDefault(require("fuse.js"));
var lodash_1 = require("lodash");
var use_deep_compare_effect_1 = __importDefault(require("use-deep-compare-effect"));
var objectUtilities_1 = require("../../util/objectUtilities");
var timingHooks_1 = require("../timingHooks");
function useFuzzySearch(_a) {
    var fuzzyPair = _a.fuzzyPair, values = _a.values, options = _a.options, searchText = _a.searchText, setSearchedIds = _a.setSearchedIds;
    var debouncedSearchText = (0, timingHooks_1.useDebouncedValue)(searchText.trim()) || '';
    (0, use_deep_compare_effect_1.default)(function () {
        if (debouncedSearchText && !!values.length) {
            var results = SearchHooks.getFuzzySearchResults({
                fuzzyPair: fuzzyPair,
                searchText: debouncedSearchText,
                values: values,
                options: options,
            });
            setSearchedIds(results.map(function (_a) {
                var id = _a.id;
                return id;
            }));
        }
        else if (!debouncedSearchText) {
            setSearchedIds(undefined);
        }
    }, [fuzzyPair, options, debouncedSearchText, setSearchedIds, values]);
}
exports.useFuzzySearch = useFuzzySearch;
function getFuzzySearchResults(_a) {
    var _b = _a.fuzzyPair, calculateAttributes = _b.calculateAttributes, keys = _b.keys, values = _a.values, options = _a.options, searchText = _a.searchText;
    return (0, lodash_1.compact)(new fuse_js_1.default(values.map(calculateAttributes), __assign({ keys: Array.isArray(keys)
            ? keys
            : (0, objectUtilities_1.keys)(keys).map(function (key) { return ({
                name: key,
                weight: keys[key].weight,
            }); }), includeScore: true, shouldSort: true, minMatchCharLength: searchText.trim().length > 1 ? 2 : undefined, threshold: 0.25, ignoreLocation: true }, options))
        .search(searchText)
        .map(function (_a) {
        var item = _a.item;
        return values.find(function (_a) {
            var id = _a.id;
            return item.id === id;
        });
    }));
}
exports.getFuzzySearchResults = getFuzzySearchResults;
var SearchHooks = {
    useFuzzySearch: useFuzzySearch,
    getFuzzySearchResults: getFuzzySearchResults,
};
exports.default = SearchHooks;
